/** Formatting that must read the same in the app and in a static snapshot. */

/** How long a game counts as new. */
export const NEW_FOR_MS = 14 * 24 * 60 * 60 * 1000;

/** True when the game arrived within {@link NEW_FOR_MS} of `now` (never when `now` is unknown). */
export function isNewGame(liveAt: string, now: number): boolean {
  if (!now) return false;
  const at = Date.parse(liveAt);
  return Number.isFinite(at) && at <= now && now - at < NEW_FOR_MS;
}

const DATE = new Intl.DateTimeFormat('en-US', {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
  timeZone: 'UTC',
});

/** "Oct 24, 2026" — in UTC, so a server and a browser agree. */
export function formatGameDate(iso: string): string {
  const at = Date.parse(iso);
  return Number.isFinite(at) ? DATE.format(at) : '';
}

/** "1 game", "12 games". */
export function gameCount(n: number): string {
  return `${n} ${n === 1 ? 'game' : 'games'}`;
}

/** An "about" text's paragraphs (blank lines between them). */
export function paragraphs(text: string): string[] {
  return text
    .split(/\n\s*\n/)
    .map((p) => p.trim())
    .filter(Boolean);
}
